<div class="change-main-collaborator-modal">
  <h2 mat-dialog-title class="modal-title">
    <mat-icon class="title-icon">swap_horiz</mat-icon>
    Cambiar Usuario Asociado
  </h2>

  <mat-dialog-content class="modal-content">
    <!-- Información de la Ruta (Solo Lectura) -->
    <div class="route-info-section">
      <h3 class="section-title">
        <mat-icon>route</mat-icon>
        Información de la Ruta
      </h3>

      <div class="info-grid">
        <div class="info-item">
          <label class="info-label">Código:</label>
          <span class="info-value">{{ getRouteCode() }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">Nombre:</label>
          <span class="info-value">{{ subRoute.name }}</span>
        </div>

        <div class="info-item">
          <label class="info-label">Tipo:</label>
          <span class="info-value">{{ getRouteType() }}</span>
        </div>
      </div>
    </div>

    <mat-divider class="section-divider"></mat-divider>

    <!-- Usuario Actual -->
    <div class="current-user-section" *ngIf="currentUser">
      <h3 class="section-title">
        <mat-icon>person</mat-icon>
        Usuario Actual
      </h3>

      <div class="user-info-card current-user-card">
        <mat-icon class="user-icon">account_circle</mat-icon>
        <div class="user-details">
          <span class="user-name">
            {{ currentUser.businessPartner?.name || 'Sin nombre' }}
          </span>
          <span class="user-username" *ngIf="currentUser.businessPartner?.username">
            {{ '@' + currentUser.businessPartner.username }}
          </span>
        </div>
      </div>
    </div>

    <div class="no-current-user" *ngIf="!currentUser">
      <mat-icon>person_off</mat-icon>
      <span>No hay usuario asociado actualmente</span>
    </div>

    <mat-divider class="section-divider"></mat-divider>

    <!-- Selección de Nuevo Usuario -->
    <div class="user-selection-section">
      <h3 class="section-title">
        <mat-icon>person_add</mat-icon>
        Seleccionar Nuevo Usuario
      </h3>

      <div class="form-field-wrapper">
        <label for="user-select" class="field-label">Usuario *</label>
        <ng-select
          [formControl]="userControl"
          [items]="mainCollabList"
          bindLabel="username"
          bindValue="masterUserId"
          notFoundText="No se encontraron usuarios disponibles"
          [searchable]="true"
          placeholder="Seleccione el usuario"
          name="masterUserId"
          [compareWith]="compareByMaster"
          [appendTo]="'body'"
          (change)="onUserSelectionChange($event)"
          class="user-select"
        >
          <ng-template ng-label-tmp let-item="item">
            <div class="select-label">
              <span class="username">{{ item.username }}</span>
              <span class="business-name" *ngIf="item.businessPartnerName">
                - {{ item.businessPartnerName }}
              </span>
            </div>
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            <div class="select-option">
              <span class="username">{{ item.username }}</span>
              <span class="business-name" *ngIf="item.businessPartnerName">
                - {{ item.businessPartnerName }}
              </span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Información del Usuario Seleccionado -->
      <div class="selected-user-info" *ngIf="selectedUser">
        <h4 class="subsection-title">Información del Usuario Seleccionado</h4>

        <div class="user-info-card selected-user-card">
          <mat-icon class="user-icon">check_circle</mat-icon>
          <div class="user-details">
            <span class="user-name">
              {{ selectedUser.businessPartnerName || 'Sin nombre' }}
            </span>
            <span class="user-username">{{ '@' + selectedUser.username }}</span>
            <span class="user-id"> ID: {{ selectedUser.masterUserId }} </span>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="modal-actions">
    <button mat-button (click)="onCancel()" [disabled]="isLoading" class="cancel-button">
      <mat-icon>close</mat-icon>
      Cancelar
    </button>

    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="changeUserForm.invalid || isLoading"
      class="save-button"
    >
      <mat-icon *ngIf="!isLoading">save</mat-icon>
      <mat-icon *ngIf="isLoading" class="spinning">sync</mat-icon>
      {{ isLoading ? 'Guardando...' : 'Guardar Cambios' }}
    </button>
  </mat-dialog-actions>
</div>
